// Vendors
import { useState } from 'react';
// Handlers
import { FinancialDataHandlers } from '../handlers/financial-data.handlers';
// Contexts
import { useContractContextConsumerHook } from 'containers/contract/contexts/contract.context';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Types
import { ContractFinancialDataHookType } from './types/financial-data.hook.type';

const useContractFinancialDataHook = (): ContractFinancialDataHookType => {
  const [showIbanSelector, setShowIbanSelector] = useState<boolean>(false);
  const { setFlowApiData } = useLayoutContextConsumerHook();
  const { setError } = useFetchErrorContextConsumerHook();
  const { ibanList, selectedIban, setFetchingSave } = useContractContextConsumerHook();

  const { handleCloseIbanSelector, handleSaveChangedIban } = FinancialDataHandlers({
    ibanList,
    selectedIban,
    setError,
    setFetchingSave,
    setFlowApiData,
    setShowIbanSelector,
  });

  return { handleCloseIbanSelector, handleSaveChangedIban, showIbanSelector, setShowIbanSelector };
};

export { useContractFinancialDataHook };
